"use client"

import * as React from "react"
import { cn } from "@/lib/utils"
import {
  Table as ShadcnTable,
  TableHeader as ShadcnTableHeader,
  TableBody as ShadcnTableBody,
  TableFooter as ShadcnTableFooter,
  TableHead as ShadcnTableHead,
  TableRow as ShadcnTableRow,
  TableCell as ShadcnTableCell,
  TableCaption as ShadcnTableCaption,
} from "@/components/shadcn/table"

// Extended Table with custom styles for the UI
function Table({ className, ...props }: React.ComponentProps<typeof ShadcnTable>) {
  return (
    <ShadcnTable
      className={cn(
        "border-separate border-spacing-0 rounded-lg bg-white shadow-sm text-sm [&_th]:bg-gray-50 [&_th]:font-semibold [&_th]:text-gray-700 [&_td]:bg-white [&_tr]:border-b [&_tr:last-child]:border-b-0",
        className
      )}
      {...props}
    />
  )
}

function TableHeader({ className, ...props }: React.ComponentProps<typeof ShadcnTableHeader>) {
  return (
    <ShadcnTableHeader
      className={cn("", className)}
      {...props}
    />
  )
}

function TableBody({ className, ...props }: React.ComponentProps<typeof ShadcnTableBody>) {
  return (
    <ShadcnTableBody
      className={cn("", className)}
      {...props}
    />
  )
}

function TableFooter({ className, ...props }: React.ComponentProps<typeof ShadcnTableFooter>) {
  return (
    <ShadcnTableFooter
      className={cn("", className)}
      {...props}
    />
  )
}

function TableHead({ className, ...props }: React.ComponentProps<typeof ShadcnTableHead>) {
  return (
    <ShadcnTableHead
      className={cn(
        "px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider border-b border-gray-200 bg-gray-50",
        className
      )}
      {...props}
    />
  )
}

function TableRow({ className, ...props }: React.ComponentProps<typeof ShadcnTableRow>) {
  return (
    <ShadcnTableRow
      className={cn(
        "hover:bg-gray-100 transition-colors border-b border-gray-200 last:border-b-0",
        className
      )}
      {...props}
    />
  )
}

function TableCell({ className, ...props }: React.ComponentProps<typeof ShadcnTableCell>) {
  return (
    <ShadcnTableCell
      className={cn(
        "px-4 py-3 align-middle text-gray-900 whitespace-nowrap border-b border-gray-200",
        className
      )}
      {...props}
    />
  )
}

function TableCaption({ className, ...props }: React.ComponentProps<typeof ShadcnTableCaption>) {
  return (
    <ShadcnTableCaption
      className={cn("text-gray-500 mt-4 text-xs", className)}
      {...props}
    />
  )
}

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
}
